// Los van de UmlDiagramItem-boom: verbindt twee UmlShape-instanties.
import umlSelectionEngine from '../Core/UmlSelectionEngine';

class UmlConnector {
    constructor(id, fromShapeId, toShapeId, kind) {
        this.id = id;
        this.fromShapeId = fromShapeId;
        this.toShapeId = toShapeId;
        this.kind = kind; // 'association' | 'inheritance' | 'dependency' | ...
        this.label = null; // UmlCaption
        this.points = []; // UmlConnectorPoint[]
        this.style = null; // {dash, arrowHead, color, strokeWidth} — data vs afleiding van kind: nog open, zie design V1 punt 4
        this.fromAnchorPoint = null; // {x,y} | null — manual border anchor override for the from-end, null = auto (toward other end)
        this.toAnchorPoint = null; // {x,y} | null — manual border anchor override for the to-end, null = auto
    }

    addPoint(connectorPoint) {
        this.points.push(connectorPoint);
    }

    // Voegt een buigpunt in op een specifieke positie (dubbelklik-op-lijn-segment,
    // zie UmlCanvas.jsx findNearestSegmentIndex) i.p.v. altijd achteraan (addPoint,
    // gebruikt door de Q-toets-tijdens-tekenen-flow, waar append altijd al klopt
    // omdat je in volgorde sleept). index correspondeert 1-op-1 met het segment
    // (start/vorig-punt -> volgend-punt/end) waar de klik het dichtst bij lag.
    insertPoint(index, connectorPoint) {
        this.points.splice(index, 0, connectorPoint);
    }

    removePoint(pointId) {
        this.points = this.points.filter(function filterOutPoint(point) {
            return point.id !== pointId;
        });
    }

    setLabel(caption) {
        this.label = caption;
    }

    // Zelfde centralisatie-reden als UmlDiagramItem.select() — UmlConnector zit
    // buiten die boom (geen eigen x/y), dus krijgt zijn eigen kopie i.p.v. erven.
    select() {
        umlSelectionEngine.select(this.id);
    }

    // Ankers hebben geen eigen object/id (alleen {x,y} op de connector zelf) —
    // synthetische selectie-key "connectorId:variant", zie UmlConnectorEndpoints.jsx.
    selectAnchor(variant) {
        umlSelectionEngine.select(`${this.id}:${variant}`);
    }
}

export default UmlConnector;
